import smoothscroll from 'smoothscroll-polyfill';

smoothscroll.polyfill();

const scrollTo = ({ left, top, behavior = 'smooth' }) => {
  // timeout hack for firefox
  setTimeout(() => {
    window.scrollTo({
      left,
      top,
      behavior,
    });
  }, 50);
};

export default scrollTo;
